// extracted by mini-css-extract-plugin
module.exports = {"paper":"Home_paper__1G3xD","divider":"Home_divider__36QA1","header":"Home_header__1vgcw"};